export const urlBase64ToUint8Array = (base64String) => {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/[-]/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};

export const getTimeRange = (period) => {
  let startTime, endTime;
  
  switch(period) {
    case 'today':
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      startTime = today.getTime();
      endTime = Date.now();
      break;
    case 'yesterday':
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      yesterday.setHours(0, 0, 0, 0);
      startTime = yesterday.getTime();
      const yesterdayEnd = new Date(yesterday);
      yesterdayEnd.setHours(23, 59, 59, 999);
      endTime = yesterdayEnd.getTime();
      break;
    case 'dayBeforeYesterday':
      const dayBefore = new Date();
      dayBefore.setDate(dayBefore.getDate() - 2);
      dayBefore.setHours(0, 0, 0, 0);
      startTime = dayBefore.getTime();
      const dayBeforeEnd = new Date(dayBefore);
      dayBeforeEnd.setHours(23, 59, 59, 999);
      endTime = dayBeforeEnd.getTime();
      break;
    case 'week':
      const weekStart = new Date();
      const dayOfWeek = weekStart.getDay();
      const diff = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
      weekStart.setDate(weekStart.getDate() - diff);
      weekStart.setHours(0, 0, 0, 0);
      startTime = weekStart.getTime();
      endTime = Date.now();
      break;
    case 'month':
      const monthStart = new Date();
      monthStart.setDate(1);
      monthStart.setHours(0, 0, 0, 0);
      startTime = monthStart.getTime();
      endTime = Date.now();
      break;
    default:
      startTime = 0;
      endTime = Date.now();
  }
  
  return { startTime, endTime };
};

export const filterContracts = (contracts, { period, categoria, mandante }) => {
  const { startTime, endTime } = getTimeRange(period);
  
  let filtered = contracts.filter(c => c.timestamp >= startTime && c.timestamp <= endTime);
  
  // Produzione filters
  if (categoria !== 'all' && contracts[0]?.mandante) {
    filtered = filtered.filter(c => c.categoria === categoria);
  }
  
  if (mandante !== 'all' && contracts[0]?.mandante) {
    filtered = filtered.filter(c => c.mandante === mandante);
  }
  
  // Rebelnet filters (categoria = campaign_id, mandante = list_id - list_name)
  if (categoria !== 'all' && contracts[0]?.campaign_id) {
    filtered = filtered.filter(c => c.campaign_id === categoria);
  }
  
  if (mandante !== 'all' && contracts[0]?.list_id) {
    const listId = mandante.split(' - ')[0];
    filtered = filtered.filter(c => c.list_id === listId);
  }
  
  return filtered;
};

export const calculateStats = (contracts) => {
  const stats = {
    total: contracts.length,
    byMandante: {},
    byCategoria: {},
    byRisk: {},
    byList: {},
    byCampaign: {},
    byStatus: {}
  };
  
  contracts.forEach(item => {
    // Produzione stats
    if (item.mandante) {
      stats.byMandante[item.mandante] = (stats.byMandante[item.mandante] || 0) + 1;
    }
    if (item.categoria) {
      stats.byCategoria[item.categoria] = (stats.byCategoria[item.categoria] || 0) + 1;
    }
    if (item.risk) {
      stats.byRisk[item.risk] = (stats.byRisk[item.risk] || 0) + 1;
    }
    
    // Rebelnet stats
    if (item.list_id) {
      const listKey = item.list_name ? `${item.list_id} - ${item.list_name}` : item.list_id;
      stats.byList[listKey] = (stats.byList[listKey] || 0) + 1;
    }
    if (item.campaign_id) {
      stats.byCampaign[item.campaign_id] = (stats.byCampaign[item.campaign_id] || 0) + 1;
    }
    if (item.status) {
      stats.byStatus[item.status] = (stats.byStatus[item.status] || 0) + 1;
    }
  });
  
  return stats;
};

export const getPeriodLabel = (period) => {
  const labels = {
    today: 'Oggi',
    yesterday: 'Ieri',
    dayBeforeYesterday: "L'altro ieri",
    week: 'Settimana',
    month: 'Mese'
  };
  return labels[period] || period;
};
